import { render, staticRenderFns } from "./InformationDialog.vue?vue&type=template&id=34f03984&scoped=true"
import script from "./InformationDialog.vue?vue&type=script&lang=js"
export * from "./InformationDialog.vue?vue&type=script&lang=js"
import style0 from "./InformationDialog.vue?vue&type=style&index=0&id=34f03984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f03984",
  null
  
)

export default component.exports